import React, { useState } from "react";
import { Button } from "@mui/material";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const RemoveDuplicatesButton = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleRemoveDuplicates = async () => {
    setLoading(true);
    setMessage("");

    try {
      const res = await axios.delete(`${API_URL}/remove-duplicate-experts/`);
      setMessage(res.data.message);
    } catch (error) {
      setMessage("Error removing duplicates.");
    }
    setLoading(false);
  };

  return (
    <div>
      <Button
        variant="contained"
        color="error"
        onClick={handleRemoveDuplicates}
        disabled={loading}
      >
        {loading ? "Removing..." : "Remove Duplicate Experts"}
      </Button>

      {message && (
        <p style={{ marginTop: "10px", color: "#FF6F61" }}>
          {message}
        </p>
      )}
    </div>
  );
};

export default RemoveDuplicatesButton;
